module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc5-9cb859c26c447fc3a940f0a8f7178dbb.jpg";